import request from "../request";

export default {
  //作品-列表
  lists(data) {
    return request.get("/adminWorks/lists", data);
  },
	

};
